module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n8r5n1n-3dc2114ee19cb9f2480c3caa3b15188c.svg";